import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import SAlert from "components/Alert"
import useSearch from "hooks/useSearch"
import AdjustmentDetailModal from "components/Adjustment/details"
import AdjustmentActionRequestListComponent from "components/ProviderActionRequests/Adjustments/list"
import {
  getAdjustmentActionRequests,
  sendAdjustmentActionRequests,
} from "store/provider-action-requests/provider-action-request-action"
import {
  getItemCategories,
  getUsers,
} from "store/admin/admin-dashboard-action"

const AdjustmentActionRequestList = () => {
  document.title = "Adjustment Action Requests"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(
    state => state.provActionRequests
  )
  const [adjustment, setAdjustment] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  // Handle multiple delete action when top delete button is clicked
  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(sendAdjustmentActionRequests(ids, "Delete"))
    } else {
      SAlert({ text: "no adjustment selected", status: "info" })
    }
  }

  // Handle cancel action for multiple delete when cancel button is clicked
  const onCancelDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(sendAdjustmentActionRequests(ids, "Cancel"))
    } else {
      SAlert({ text: "no adjustment selected", status: "info" })
    }
  }

  // Fetches new adjustment action requests when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getAdjustmentActionRequests(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getAdjustmentActionRequests(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new Adjustment Action Requests based page number or according changes
  useEffect(() => {
    dispatch(
      getAdjustmentActionRequests(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch needed data for adjustment action request
  useEffect(() => {
    dispatch(getItemCategories())
    dispatch(getUsers(2))
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getAdjustmentActionRequests(
        undefined,
        undefined,
        undefined,
        search,
        data
      )
    )
  }

  // Show adjustment details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setAdjustment(data)
    setDetailModal(true)
  }

  return (
    <React.Fragment>
      {/* Modal Component */}
      <AdjustmentDetailModal
        open={detailModal}
        setOpen={setDetailModal}
        data={adjustment}
      />

      <Breadcrumbs
        title={"Admin"}
        breadcrumbItem={"Adjustment Delete Requests"}
      />
      <AdjustmentActionRequestListComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onCancelDeleteClicked={onCancelDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onClickDetail={onClickDetail}
      />
    </React.Fragment>
  )
}

export default AdjustmentActionRequestList
